module.exports = __webpack_public_path__ + "img/deep2.032ec3ce.png";